import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import type { WidgetNavigateEvent } from "@circle-react/components/HelpWidget/hooks/useWidgetNavigate";
import { WIDGET_NAVIGATE_EVENT } from "@circle-react/components/HelpWidget/hooks/useWidgetNavigate";

export const useWidgetNavigationListener = () => {
  const history = useHistory();

  useEffect(() => {
    const handleWidgetNavigate = (event: Event) => {
      const navigateEvent = event as WidgetNavigateEvent;
      const { url } = navigateEvent.detail;

      // The check for http/https is to support absolute URLs in the future,
      // but also to support old Copilot conversations that might have absolute URLs.
      if (url.startsWith("http://") || url.startsWith("https://")) {
        window.location.href = url;
      } else {
        history.push(url);
      }
    };

    document.addEventListener(WIDGET_NAVIGATE_EVENT, handleWidgetNavigate);

    return () => {
      document.removeEventListener(WIDGET_NAVIGATE_EVENT, handleWidgetNavigate);
    };
  }, [history]);
};
